"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var DialogActionsTheme = function DialogActionsTheme(breakpoints) {
  var _root;

  return {
    styleOverrides: {
      root: (_root = {
        padding: '14px 20px',
        flexDirection: 'column-reverse',
        alignItems: 'stretch'
      }, (0, _defineProperty2["default"])(_root, breakpoints.up('sm'), {
        padding: '14px 32px',
        flexDirection: 'row',
        alignItems: 'center'
      }), (0, _defineProperty2["default"])(_root, '&>:not(:first-of-type)', (0, _defineProperty2["default"])({
        marginLeft: 0,
        marginBottom: 8
      }, breakpoints.up('sm'), {
        marginLeft: 24,
        marginBottom: 0
      })), _root)
    }
  };
};

var _default = DialogActionsTheme;
exports["default"] = _default;